import { Mail, Phone, Cake, MapPin, User } from "lucide-react";

const fmtBirth = (d) => { try { return new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }); } catch { return d; } };

export const AccountInfo = ({ user }) => {
  const fullName = [user.civility, user.first_name, user.last_name].filter(Boolean).join(" ");
  const street = [user.addr_street_no, user.addr_street].filter(Boolean).join(" ");
  const town = [user.addr_postal_code, user.addr_city].filter(Boolean).join(" ");
  const address = [street, user.addr_complement, town, user.addr_country].filter(Boolean).join(", ");
  const rows = [
    { icon: User, value: fullName, id: "name" },
    { icon: Mail, value: user.email, id: "email" },
    { icon: Phone, value: user.phone_mobile, id: "phone" },
    { icon: Cake, value: user.birthdate && fmtBirth(user.birthdate), id: "birthdate" },
    { icon: MapPin, value: address, id: "address" },
  ].filter((r) => r.value);
  return (
    <div className="mt-3 space-y-1.5 text-sm text-muted-foreground" data-testid="account-info">
      {rows.map(({ icon: Icon, value, id }) => (
        <p key={id} className="flex items-center justify-center gap-1.5" data-testid={`account-info-${id}`}>
          <Icon className="w-4 h-4 shrink-0" /> <span>{value}</span>
        </p>
      ))}
    </div>
  );
};
